import React, { Fragment, } from "react";
import { Nav, NavItem, Tab as BSTab } from "react-bootstrap";
import { Title } from "./Title";
import { IconOptions } from "./utils/iconOptions";
export var TabContainer = function (_a) {
    var defaultTab = _a.defaultTab, id = _a.id, children = _a.children, activeTab = _a.activeTab, onChange = _a.onChange, className = _a.className;
    return (React.createElement(BSTab.Container, { id: id, defaultActiveKey: defaultTab, activeKey: activeTab, onSelect: onChange, className: className },
        React.createElement(BSTab.Content, { animation: false }, children)));
};
export var TabMenu = function (_a) {
    var items = _a.items, _b = _a.type, type = _b === void 0 ? "horizontal" : _b, _c = _a.title, title = _c === void 0 ? "" : _c, _d = _a.titleLevel, titleLevel = _d === void 0 ? "h3" : _d, children = _a.children, dataHook = _a.dataHook;
    var className = undefined;
    if (type === "bar") {
        className = "tab-nav-bar";
    }
    return (React.createElement(Nav, { bsStyle: "tabs", stacked: type === "stacked", bsClass: className, "data-hook": dataHook },
        title && (React.createElement(Title, { titleLevel: titleLevel },
            React.createElement(Fragment, null, title))),
        items.map(function (item, i) {
            var iconType = item.icon && IconOptions[item.icon].type === "pro"
                ? "glyphicon-pro"
                : "glyphicon";
            return (React.createElement(NavItem, { key: i, eventKey: item.name, disabled: item.disabled, onClick: item.onClick, id: item.id },
                item.icon && (React.createElement("span", { className: "icon ".concat(iconType, " ").concat(iconType, "-").concat(IconOptions[item.icon].value) })),
                item.label,
                type === "stacked" && item.extra && (React.createElement("span", { className: "tab-nav-item--extra" }, item.extra))));
        }),
        children));
};
export var TabContent = function (_a) {
    var children = _a.children;
    return React.createElement(BSTab.Content, { animation: false }, children);
};
export var TabPane = function (_a) {
    var children = _a.children, name = _a.name;
    return React.createElement(BSTab.Pane, { eventKey: name }, children);
};
export var Tab = {
    Container: TabContainer,
    Menu: TabMenu,
    Pane: TabPane,
    Content: TabContent,
};
